import {ClickEvent} from "../../../../../infrastructure/models/analytics/click-event";
import {APP} from "../../../../../core/app/consts";

export class FooterModuleItemClickEvent extends ClickEvent {
  itemType: String;
  screen: APP.ANALYTICS.SCREENS;

  constructor(params: FooterModuleItemClickEvent, screen: APP.ANALYTICS.SCREENS) {
    super('click', 'item', 'footer');

    this.itemType = params.itemType;
    this.screen = screen;
  }

  get properties() {
    const properties = super.properties;

    properties.itemType = this.itemType;
    properties.screen = this.screen;

    return properties;
  }

}
